export enum MessageType {
  Answer = 'answer',
  Connected = 'connected',
  Disconnected = 'disconnected',
  Host = 'host',
  Message = 'message',
  Prompt = 'prompt',
  Question = 'question',
  Ready = 'ready',
  Reset = 'reset',
  Response = 'response',
  Waiting = 'waiting'
}
